<div class="example-header">
  <button mat-icon-button (click)="previousClicked('year')">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <span class="example-header-label">{{periodLabel}}</span>
  <button mat-icon-button (click)="nextClicked('year')">
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>
